import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import { parseToNumber, sleep } from "../../utils/helper";
import {
  Button,
  Thead,
  Tbody,
  Tr,
  Td,
  Input,
  Flex,
  Text,
  Box,
  IconButton,
  AlertDialog,
  Center,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  HStack,
  useDisclosure,
  Tooltip,
} from "@chakra-ui/react";
import { Table } from "@chakra-ui/react";
import { TiDelete, BiServer } from "react-icons/all";
import "./NationalTable.css";
import { touristByNationalityColumn } from "../../constants/tableData";

function TouristByNationalityTable({ data, filter, status, onSaveAll, onRevertAll, isAllowAdd, isAllowEdit }) {
  const [selected, setSelected] = useState([]);
  const { isOpen: isDeleteModalOpen, onOpen: onDeleteModalOpen, onClose: onDeleteModalClose } = useDisclosure();
  useEffect(() => {
    //map all column and sum total of the colum
    touristByNationalityColumn.forEach((column) => {
      _calcSubTotal(column.columnId);
    });
  }, []);

  // This function is use to calculate the value in all the input when on key up
  const _calcPayRaise = (id) => {
    let underAge12 = parseInt(document.getElementById(`tourist-by-nationality-underAge12-${id}`).value);
    let age12To25 = parseInt(document.getElementById(`tourist-by-nationality-age12To25-${id}`).value);
    let age26To59 = parseInt(document.getElementById(`tourist-by-nationality-age26To59-${id}`).value);
    let age60Up = parseInt(document.getElementById(`tourist-by-nationality-age60Up-${id}`).value);
    let male = parseInt(document.getElementById(`tourist-by-nationality-male-${id}`).value);
    let female = parseInt(document.getElementById(`tourist-by-nationality-female-${id}`).value);

    // check if the value is
    if (isNaN(underAge12)) {
      underAge12 = 0;
    }
    if (isNaN(age12To25)) {
      age12To25 = 0;
    }
    if (isNaN(age26To59)) {
      age26To59 = 0;
    }
    if (isNaN(age60Up)) {
      age60Up = 0;
    }
    if (isNaN(male)) {
      male = 0;
    }
    if (isNaN(female)) {
      female = 0;
    }

    // Temporary variable use for calculate
    let totalAgeTmp = 0;
    let totalGenderTmp = 0;

    // total
    totalAgeTmp = underAge12 + age12To25 + age26To59 + age60Up;
    totalGenderTmp = male + female;

    // call Input field for display to UI
    let totalAge = document.getElementById(`tourist-by-nationality-totalAge-${id}`);
    let totalGender = document.getElementById(`tourist-by-nationality-totalGender-${id}`);

    // display to UI
    totalAge.value = totalAgeTmp;
    totalGender.value = totalGenderTmp;

    touristByNationalityColumn.forEach((column) => {
      _calcSubTotal(column.columnId);
    });
  };

  // This function use to set input value to 0 when the input is empty
  const _invalidValue = (columnId, id) => {
    let inputValue = document.getElementById(`tourist-by-nationality-${columnId}-${id}`);
    if (inputValue.value === "") {
      inputValue.value = 0;
    } else {
      inputValue.value = parseInt(inputValue.value);
    }
  };

  // This function is use to calculate Total value
  const _calcSubTotal = (column) => {
    let subColumn = document.getElementsByClassName(`tourist-by-nationality-${column}`);

    let total = 0;
    for (let each of subColumn) {
      if (each.value === "") {
        each.value = 0;
      }
      if (!isNaN(parseInt(each.value))) {
        total += parseInt(each.value);
      } else {
        total += parseToNumber(each.value);
      }
    }

    let totalColumn = document.getElementById(`total-tourist-by-nationality-${column}`);
    if (totalColumn) {
      totalColumn.innerHTML = total;
    }
  };
  return (
    <>
      <AlertDialog motionPreset="slideInBottom" isOpen={isDeleteModalOpen} isCentered>
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg">Confirmation</AlertDialogHeader>

          <AlertDialogBody>{`Are you sure you want to revert ${selected.length > 1 ? "these tourist by nationalities?" : "this tourist by nationality?"}`}</AlertDialogBody>
          <AlertDialogFooter>
            <HStack spacing="2">
              <Button onClick={onDeleteModalClose}>No</Button>
              <Button
                colorScheme="red"
                onClick={async () => {
                  onRevertAll(selected);
                  await sleep(100);
                  onDeleteModalClose();
                }}
              >
                Yes
              </Button>
            </HStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <Box style={{ position: "sticky", left: "0" }} w="100%" mb="10px">
        <Text textAlign="center" fontSize="25px" fontWeight="bold">
          Nationality Tourist Buying Ticket to Angkor
        </Text>
        {status === "filter" ? (
          <Text textAlign="center">
            Tourist by Nationality from {format(new Date(filter?.dateFrom), "dd MMMM, yyyy")} to {format(new Date(filter?.dateTo), "dd MMMM, yyyy")}
          </Text>
        ) : status === "import" ? (
          <Text textAlign="center">
            Tourist Buying Ticket from {data?.length > 0 && format(new Date(data[0]?.date), "dd MMMM, yyyy")} to {data?.length > 0 && format(new Date(data[data?.length - 1]?.date), "dd MMMM, yyyy")}
          </Text>
        ) : status === "retrieve" && filter !== undefined ? (
          <Text textAlign="center">
            Tourist Buying Ticket from {format(new Date(filter?.dateFrom), "dd MMMM, yyyy")} to {format(new Date(filter?.dateTo), "dd MMMM, yyyy")}
          </Text>
        ) : (
          ""
        )}
      </Box>

      {data?.length > 0 ? (
        <Table w="100%" size="sm" className="national-table" borderRight="1px solid black">
          <Thead className="national-thead">
            <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className="national-thead-tr1">
              <Td textAlign="center" p="0">
                No
              </Td>
              <Td textAlign="center" p="0">
                DATE
              </Td>
              <Td textAlign="center" p="0">
                COUNTRY
              </Td>
              <Td textAlign="center" p="0">
                Under Age 12
              </Td>
              <Td textAlign="center" p="0">
                Age 12 - 25
              </Td>
              <Td textAlign="center" p="0">
                Age 26 - 59
              </Td>
              <Td textAlign="center" p="0">
                Age 60 Up
              </Td>
              <Td textAlign="center" p="0">
                TOTAL
              </Td>
              <Td textAlign="center" p="0">
                Female
              </Td>
              <Td textAlign="center" p="0">
                Male
              </Td>
              <Td textAlign="center" p="0">
                Total Gender
              </Td>
              <Td textAlign="center" p="0">
                ស្ថានភាព
              </Td>
            </Tr>
          </Thead>

          <Tbody>
            {data?.map((data, index) => {
              return (
                <Tr key={index} h="25px">
                  {touristByNationalityColumn.map((item, i) => {
                    return (
                      <Td key={i} /* w={`${item.w} "!important"`}  */ py="0" p="1">
                        <Input
                          padding="2px"
                          width="100%"
                          height="30px"
                          textAlign={item.textAlign}
                          borderColor="gray.300"
                          type={item.type}
                          className={`tourist-by-nationality-${item.columnId} ${item.readOnly ? "is-disable-input" : data.status === 1 ? "is-disable-input" : ""}`}
                          id={`tourist-by-nationality-${item.columnId}-${data.id}`}
                          defaultValue={data[item.columnId]}
                          onKeyUp={() => _calcPayRaise(`${data.id}`)}
                          onBlur={() => {
                            _invalidValue(item.columnId, data.id);
                          }}
                        />
                      </Td>
                    );
                  })}
                  <Td width="5%" align="center" py="0">
                    <Flex justifyContent="center">
                      <Button className={data.status === 1 ? "ut-button-dark" : "ut-button-success"} w="20" h="30px" id={`btn-save-${data.id}`} onClick={() => onSaveAll([data])} hidden={!isAllowAdd}>
                        {data.status === 1 ? "Saved" : "Save"}
                      </Button>
                      <Tooltip hasArrow label="Revert" color="black" bg="gray.300">
                        <IconButton
                          onClick={() => {
                            onDeleteModalOpen();
                            setSelected([data]);
                          }}
                          hidden={!isAllowEdit}
                          id={`btn-revert-${data.id}`}
                          className={data.status !== 1 ? "is-disable" : ""}
                          variant="ghost"
                          colorScheme="red"
                          size="sm"
                          icon={<TiDelete size="1.7rem" />}
                        />
                      </Tooltip>
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
            <Tr h="35px">
              {touristByNationalityColumn.map((item, i) => {
                return (
                  <Td key={i} p="0" style={{ backgroundColor: "#8497b0", color: "white", textAlign: "center" }}>
                    {i === 1 ? "Total" : i === 0 ? null : <span id={`total-tourist-by-nationality-${item.columnId}`} />}
                  </Td>
                );
              })}
              <Td p="0" style={{ backgroundColor: "#8497b0" }}></Td>
            </Tr>
          </Tbody>
        </Table>
      ) : (
        <Center py="3" w="full" h="70vh" color="gray.400">
          <BiServer size="1.3rem" /> <Text fontSize="md">&nbsp;No data.</Text>
        </Center>
      )}
    </>
  );
}

export default TouristByNationalityTable;
